import { makeStub } from "./_base";
export const PurchaseInvoice = makeStub("PurchaseInvoice");
